import { Component, OnInit } from '@angular/core';
import {CmsPageService} from '../../services/cms.page.service';
import {CmsPageType} from '../../models/cms.pages/cms.pages.models';
import { GetCmsPageDto } from '../../models/cms.pages/cms.pages.models';
import { LoggedInUserService } from '../../auth/logged.in.user';

@Component({
    selector: 'registration/thankyou',
    template: require('./thank.you.component.html')
})
export class ThankYouComponent implements OnInit{
    pageContent: string;
    email: string;

    constructor(private readonly cmsPageService: CmsPageService, private userService: LoggedInUserService,) {
        
    }

    ngOnInit() {

        this.email = this.userService.getCurrentUser().email;

        this.cmsPageService.getByType(CmsPageType.ThankYouForRegistering).subscribe((result: GetCmsPageDto) => {
            this.pageContent = result.content;
            const gtag = window['gtag'];
            gtag('set', 'user_data', {
                "email": this.email
            });
            
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/thank.you.component.ts